export default {"src":"/_next/_v/2.9.2.s15.28/_next/static/media/AmazonLogo.aa3701ef.svg","height":23,"width":73,"blurWidth":0,"blurHeight":0};